import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
// import { isCheckTimeOut } from '@/utils/auth'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000
})

// 请求拦截
service.interceptors.request.use(
    (config) => {
        // 在这个位置需要统一的去注入token
        if (store.getters.token) {
            config.headers.Authorization = `Bearer ${store.getters.token}`
        }
        return config // 必须返回配置
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    // 请求成功
    (response) => {
        const { code, msg, data } = response.data
        // 需要判断当前请求是否成功
        if (code === 0) {
            // 成功，返回解析后的数据
            if (response.request.responseURL.indexOf('/imports') > -1) {
                return response.data
            }
            // 导出
            if (response.config.params?.export) {
                return response.data
            }
            return data
        } else if (code === 401) {
            store.dispatch('user/logout')
        } else {
            // 失败（请求成功，业务失败）
            if (response.request.responseURL.indexOf('/imports') > -1) {
                return response.data
            }
            // 导出
            if (response.config.params?.export) {
                return response.data
            }
            ElMessage.error(msg)
            return Promise.reject(new Error(msg))
        }
    },
    // 请求失败
    (error) => {
        // 处理 token 超时问题
        if (error.response && error.response.data && error.response.data.code === 401) {
            // token超时
            store.dispatch('user/logout')
        }

        ElMessage.error(error.response.data.msg)
        return Promise.reject(new Error(error))
    }
)

export default service
